import { fetcher } from 'shared/utils/fetcher';
import { StoreEnum } from 'schema/storeCode';
import { upscribeRequestOnError } from './utils/upscribeRequestPromiseHandlers';
import { createParametrizedUrlWithQueryString } from '../../../constants/routes/utils';
import { useStoreValue } from '../useStore';
import { UpscribeRequestOptions } from './types';

function useUpscribeRequestWithoutSession<Data = any>() {
  const store = useStoreValue();

  return async ({
    url,
    method,
    data,
    headers,
    params: { token = '' } = {}
  }: UpscribeRequestOptions) => {
    const requestStartTime = performance.now();

    const parametrizedUrl = createParametrizedUrlWithQueryString<
      {},
      { store: StoreEnum; token?: string }
    >(url)(
      {},
      {
        store,
        ...(token ? { token } : {})
      }
    );

    try {
      const response = await fetcher
        .create()
        [method]<Data>(parametrizedUrl, data, { headers, omitCookies: true });

      return response.data;
    } catch (error: unknown) {
      return upscribeRequestOnError(error, requestStartTime);
    }
  };
}

export default useUpscribeRequestWithoutSession;
